import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import { useHistory } from 'react-router-dom'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'
import { notifyParent } from 'mailup-react-helpers'

import {
  PageHeader,
  Button,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_SIZE_LG
} from 'mailup-web-components'

import { messageState } from '../recoil/state/message'
import { pageState } from '../recoil/state/page'
import { saveCallback } from '../recoil/callbacks/callbacks'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const [redirectUrl] = useRedirectorUrl()

  const { idMessage, name, isDirty } = useRecoilValue(messageState)
  const { loaded, loading } = useRecoilValue(pageState)
  const save = useRecoilCallback(saveCallback, [])

  useEffect(() => {
    notifyParent('selectMenuItemReact', [
      'EmailOverviewTextVersion',
      redirectUrl
    ])
  }, [redirectUrl])

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Messages' }),
      'data-mu-test': 'breadcrumb-item__messages',
      className: 'test-breadcrumb-item__messages'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Email' }),
      'data-mu-test': 'breadcrumb-item__email',
      className: 'test-breadcrumb-item__email'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Saved' }),
      'data-mu-test': 'breadcrumb-item__saved',
      className: 'test-breadcrumb-item__saved',
      url: '#',
      onClick: () => history.push('/messages/email/saved')
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Overview' }),
      'data-mu-test': 'breadcrumb-item__overview',
      className: 'test-breadcrumb-item__overview',
      url: '#',
      onClick: () =>
        history.push(
          `/messages/email/${idMessage}/overview?source=emailOverviewTextVersion&op=mod`
        )
    },
    {
      label: intl.formatMessage({ id: 'Load.EmailCheckUp.TextVersionTab' }),
      'data-mu-test': 'breadcrumb-item__text-version',
      className: 'test-breadcrumb-item__text-version'
    }
  ]

  const handleSave = () => {
    save()
  }

  const ControlsComponent = () =>
    idMessage === 0 ? null : (
      <Button
        kind={BUTTON_VARIANT_PRIMARY}
        size={BUTTON_SIZE_LG}
        onClick={handleSave}
        disabled={(loading && !loaded) || !isDirty}
        data-mu-test='header__save-btn'
      >
        {intl.formatMessage({ id: 'Load.EmailCheckUp.PlainTextVersionSave' })}
      </Button>
    )

  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      title={
        idMessage > 0 && loaded
          ? name
          : intl.formatMessage({ id: 'Load.MailupCommon.Untitled' })
      }
      loading={loading && !loaded}
      ControlsComponent={ControlsComponent}
    />
  )
}

export default Header
